<template>
  <LazyHomeCommonLayout :is-blog-banner="true">
    <template #content>
      <LazyHomeSubPagesPlatformSkillMonitor />
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {LazyHomeSubPagesPlatformSkillMonitor} from "#components";
import {useSiteNavigationLd} from "~/composables/useSiteNavigationLd";
import {useSeoMeta} from "~/composables/useSeoMeta";

const { t } = useI18n();
const siteLinkScript = useSiteNavigationLd();
const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: t("seo.home.skillMonitor.title"),
  meta: [
    {
      name: 'description',
      content: t("seo.home.skillMonitor.meta.description")
    },
    {
      name: 'title',
      content: t("seo.home.skillMonitor.meta.title")
    },
    {
      name: 'robots',
      content: 'index,follow'
    }
  ],
  script: [siteLinkScript],
  link: [
    ...getHreflangLinks.value,
    { rel: 'canonical', href: getCanonical.value }
  ]
})

definePageMeta({
  // 언어별 경로를 alias로 추가
  alias: [
    '/en/home/skillMonitor',
    '/ja/home/skillMonitor',
    '/ko/home/skillMonitor',
    '/vi/home/skillMonitor',
  ]
})
</script>